// js
import React from 'react';
import EngagementItem from './EngagementItem';


const EngagementTeamItem = props => (
  <EngagementItem
    columnWidths={[5, 5, 2]}
    namePlaceholder='Team name'
    detailsPlaceholder='Personnel'
    {...props}
  />
);

export default EngagementTeamItem;



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementTeamItem.js